var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4316 8.44443H4.00383L9.83745 2.5544C10.2452 2.14274 10.2452 1.46718 9.83745 1.05552C9.74073 0.957663 9.62584 0.880029 9.49937 0.82706C9.3729 0.774091 9.23732 0.746826 9.1004 0.746826C8.96348 0.746826 8.8279 0.774091 8.70143 0.82706C8.57496 0.880029 8.46007 0.957663 8.36335 1.05552L0.742016 8.75055C0.645099 8.8482 0.568208 8.9642 0.515746 9.09189C0.463284 9.21958 0.436279 9.35648 0.436279 9.49472C0.436279 9.63297 0.463284 9.76986 0.515746 9.89755C0.568208 10.0252 0.645099 10.1412 0.742016 10.2389L7.63156 17.8494C7.72835 17.9472 7.84326 18.0247 7.96972 18.0776C8.09618 18.1305 8.23173 18.1577 8.36861 18.1577C8.50549 18.1577 8.64103 18.1305 8.76749 18.0776C8.89396 18.0247 9.00886 17.9472 9.10565 17.8494C9.20244 17.7517 9.27922 17.6357 9.3316 17.508C9.38398 17.3803 9.41095 17.2435 9.41095 17.1053C9.41095 16.9671 9.38398 16.8302 9.3316 16.7025C9.27922 16.5748 9.20244 16.4588 9.10565 16.3611L4.00383 10.5556H21.4316C22.0066 10.5556 22.4771 10.0806 22.4771 9.5C22.4771 8.91944 22.0066 8.44443 21.4316 8.44443Z",
    fill: "#F39C12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileback);
export default __webpack_public_path__ + "static/media/mobileback.01297718a38d4affd15070c2bf160af1.svg";
export { ForwardRef as ReactComponent };